import { render, staticRenderFns } from "./NotLogged.vue?vue&type=template&id=70cb054c&scoped=true&"
import script from "./NotLogged.vue?vue&type=script&lang=js&"
export * from "./NotLogged.vue?vue&type=script&lang=js&"
import style0 from "./NotLogged.vue?vue&type=style&index=0&id=70cb054c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb054c",
  null
  
)

export default component.exports